var Marionette = require('marionette')
var tmplThankYou = require('./../templates/ThankYou.html')
var translations = require('./../../../libs/translationsUtils/translations')

module.exports = Marionette.ItemView.extend({
  className: 'survey__thankyou',
  template: tmplThankYou,
  templateHelpers: function () {
    return {
      t: translations.t
    }
  }
})
